import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
import AppMenu from "./AppMenu";

export default class AppMenus extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.id,
            controllerName: 'appmenu',
            data: null,
            loading: true,
            configName: 'appmenu_grid',
            moduleName: 'مدیریت منوها',
            filters: {
                parentId: -1,
                title: "",
                onlyManager: false

            }
        };
    }
    componentDidMount() {
        this.state["filters"] = {
            parentId: isNaN(this.getCurrentFormId()) || this.isNull(this.getCurrentFormId()) ? -1 : (this.getCurrentFormId()),
            title: "",
            onlyManager: false
        };
        this.refreshData();
    }
    showSubMenu(id) {
        window.location.href = "/menues/" + id;
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "title", caption: "عنوان", show: true },
                { field: "order", caption: "ترتیب", show: true },
                { field: "icon", caption: "آیکن", show: true },
                { field: "onlyManagerString", caption: "نمایش", show: true },
                { field: "createDateString", caption: "تاریخ ثبت", show: true },
                { field: "editDateString", caption: "تاریخ بروزرسانی", show: true }
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'title' && f.show) t.push({ field: f.field, flex: 3, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.title}</a> } });
            if (f.field == 'order' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'icon' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'onlyManagerString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'editDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'createDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        t.push({
            field: 'id', filter: false, headerName: 'عملیات', cellRenderer: (props) => {
                return [
                    <a onClick={e => this.showSubMenu(props.data.id)} className="hand text-success ms-2 me-2">
                        <span className="nk-menu-text"><em className="icon ni ni-report-profit"></em>زیرمنوها</span>
                    </a>,
                    /*<a className="hand text-danger" onClick={e => this.confirmRemove(props.data.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove"><em className="icon ni ni-trash"></em><span>حذف</span></a>*/

                ]
            }
        });
        return t;
    }
    onAdd() {
        var parentId = isNaN(this.getCurrentFormId()) || this.isNull(this.getCurrentFormId()) ? 0 : (this.getCurrentFormId())
        this.removeKeyDown();
        this.showComponents({
            component: (
                <AppMenu Caller={this} ParentId={parentId} />
            ),
        });
    }
    onEdit(id) {
        var parentId = isNaN(this.getCurrentFormId()) || this.isNull(this.getCurrentFormId()) ? 0 : (this.getCurrentFormId())
        this.removeKeyDown();
        this.showComponents({
            component: <AppMenu Caller={this} Id={id} ParentId={parentId} />
        });
    }
    renderForm() {
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return (
            <div>
                <div className="nk-content-body">
                    <div className="nk-block">
                        {this.getToolBar(false, {
                            add: true,
                            print: false,
                            pdf: false,
                            excell: false,
                            remove: false,
                            config: false,
                            otherFilters: null,
                        })}
                        {this.renderAgGrid({
                            columnDefs: this.getColumns(),
                        })}
                    </div>
                </div>
            </div>
        );
    }
    render() {
        if (!this.isBlank(this.state.redirect))
            return <Navigate to={this.state.redirect} />;

        let contents = this.state.loading
            ? this.renderLoading()
            : [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">{this.renderForm()}</div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}